import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';

import AwesomeDebouncePromise from 'awesome-debounce-promise';
import Box from '@material-ui/core/Box';
import CircularProgress from '@material-ui/core/CircularProgress';
import FormControl from '@material-ui/core/FormControl'
import InputAdornment from '@material-ui/core/InputAdornment';
import Link from '@material-ui/core/Link';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import SearchIcon from '@material-ui/icons/Search';

const useStyles = makeStyles(theme => ({
    table: {
        minWidth: 650,
    },
    tableHeader: {
        backgroundColor: theme.palette.primary.main,
        '& .MuiTableCell-head': {
            color: theme.palette.primary.contrastText,
        },
        '& th:nth-child(1)': {
            width: 155
        },
        '& th:nth-child(3)': {
            width: 440
        },
    }
}));

const searchAPI = text => fetch('/admin/sms/replies?tableSearch=' + encodeURIComponent(text));
const getDataDebounced = AwesomeDebouncePromise(searchAPI, 500);

const RepliesTable = () => {
    const classes = useStyles();
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);

    const [state, setState] = useState({
        search: ''
    });

    useEffect(() => {
        getData();
    }, []);

    const getData = () => {
        setLoading(true);
        let url = `/admin/sms/replies`;
        fetch(url, {
            method: 'GET',
        })
        .then(response => {
            return response.json();
        })
        .then(result => {
            setData(result);
            setLoading(false);
        })
        .catch(reason => {
            setLoading(false);
            alert('An error prevented getting recent text messages.');
        })
    }

    const handleSearchChange = async text => {
        setState({
            ...state,
            search: text
        });
        const result = await getDataDebounced(text);
        result.json().then(result => { setData(result) });
    }

    return (
        <>
            <Box width={400}>
                <FormControl variant="outlined" margin="dense" fullWidth>
                    <OutlinedInput
                        id="search"
                        value={state.search || ''}
                        onChange={(e) => handleSearchChange(e.target.value)}
                        placeholder="Search by phone number..."
                        type="text"
                        startAdornment={
                            <InputAdornment position="start">
                                <SearchIcon />
                            </InputAdornment>
                        }
                    />
                </FormControl>
            </Box>
            <TableContainer component={Paper} variant="outlined" square>
                <Table className={classes.table} size="small">
                    {!loading && data !== null && (
                        <TableHead className={classes.tableHeader}>
                            <TableRow>
                                <TableCell align="left">Date Received</TableCell>
                                <TableCell align="left">From</TableCell>
                                <TableCell align="left">Message</TableCell>
                                <TableCell align="left">City</TableCell>
                                <TableCell align="left">Province</TableCell>
                                <TableCell align="left">Needs Followup</TableCell>
                            </TableRow>
                        </TableHead>
                    )}
                    <TableBody>
                    {!loading && data !== null && Object.entries(data).map(([i, value]) => (
                        <TableRow key={`row-${i}`}>
                            <TableCell align="left">{value.date_sent_formatted}</TableCell>
                            <TableCell align="left"><Link href={`/admin/sms/conversations?search=${value.from}`}>{value.from}</Link></TableCell>
                            <TableCell align="left">{value.message}</TableCell>
                            <TableCell align="left">{value.from_city}</TableCell>
                            <TableCell align="left">{value.from_state}</TableCell>
                            <TableCell align="left">{value.ep_reply_date ? "No" : "Yes"}</TableCell>
                        </TableRow>
                    ))}
                    {!loading && data !== null && data.length === 0 && (
                        <TableRow>
                            <TableCell colSpan={14} align="center">No data</TableCell>
                        </TableRow>
                    )}
                    {loading && (
                        <TableRow>
                            <TableCell colSpan={14} align="center">
                                <CircularProgress color="primary" />
                            </TableCell>
                        </TableRow>
                    )}
                    </TableBody>
                </Table>
            </TableContainer>
        </>
    )
}

export default RepliesTable;
